"use client";

import { useState } from "react";
import { useLocation } from "wouter";
import * as Select from '@radix-ui/react-select';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
import { useOnboardingStore } from "../../lib/onboarding";

const experiences = [
  "0-2 years",
  "3-5 years",
  "6-10 years",
  "10+ years"
];

const OnboardingStep3 = () => {
  const [, setLocation] = useLocation();
  const { experience, setExperience } = useOnboardingStore();
  const [touched, setTouched] = useState(false);

  const handleNext = () => {
    setTouched(true);
    if (!experience) {
      return;
    }
    setLocation("/onboarding/step-4");
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-slate-900 font-display">How long have you been in the game?</h2>
        <p className="mt-2 text-slate-600">We’ll pace the coaching journey to match your experience arc.</p>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="experience" className="block text-sm font-medium text-slate-700 font-sans">Years of Experience</label>
          <Select.Root value={experience ?? ''} onValueChange={setExperience}>
            <Select.Trigger id="experience" className="mt-1 w-full flex justify-between items-center rounded-md border border-input bg-white px-4 py-2 text-slate-900 shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
              <Select.Value placeholder="Select your experience level..." />
              <Select.Icon><ChevronDownIcon className="h-5 w-5 opacity-50" /></Select.Icon>
            </Select.Trigger>
            <Select.Portal>
              <Select.Content className="bg-white rounded-md shadow-lg border p-2 z-50 font-sans">
                <Select.Viewport>
                  {experiences.map(exp => (
                    <Select.Item key={exp} value={exp} className="relative flex items-center px-8 py-2 text-sm rounded-md cursor-pointer outline-none hover:bg-accent/10 focus:bg-accent/10">
                      <Select.ItemText>{exp}</Select.ItemText>
                      <Select.ItemIndicator className="absolute left-2 flex items-center text-primary"><CheckIcon className="h-5 w-5" /></Select.ItemIndicator>
                    </Select.Item>
                  ))}
                </Select.Viewport>
              </Select.Content>
            </Select.Portal>
          </Select.Root>
        </div>
        {touched && !experience && (
          <p className="text-sm text-red-600">Select the experience band that fits you best to continue.</p>
        )}
      </div>

      <div className="flex justify-between pt-4">
        <button
          type="button"
          onClick={() => setLocation("/onboarding/step-2")}
          className="inline-flex items-center justify-center px-6 py-2 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary font-display"
        >
          Back
        </button>
        <button
          type="button"
          onClick={handleNext}
          className="inline-flex items-center justify-center px-6 py-2 border border-transparent text-base font-medium rounded-md shadow-sm bg-accent !text-accent-foreground hover:bg-accent/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-accent disabled:opacity-50 font-display"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default OnboardingStep3;
